import {Injectable} from '@angular/core';
import {IProdGridService} from 'prod-grid';
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {BehaviorSubject, Observable} from 'rxjs';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';
import {IOrganizationTreeSelect} from "../dip/i-organization-tree-select";
import {OrganizationTreeSelect} from "../dip/organization-tree-select";
import {HttpClient} from "@angular/common/http";
import {Device} from "../models/device";

@Injectable({
  providedIn: 'root'
})
export class DevicesService extends AbstractProdSelectService implements IProdGridService, IOrganizationTreeSelect {
  override selectDataUrl: string = 'devices';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'name'
  };
  confirmReactivateHub$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(public override httpClient: HttpClient, private organizationTreeSelect: OrganizationTreeSelect) {
    super(httpClient);
  }

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: Device[], totalCount: number }, success: boolean }>(`/api/devices`, {params});
  }

  prodGridAdd(values: any): Observable<Object> {
    return this.httpClient.post(`/api/device`, values);
  }

  prodGridPatch(values: any, id: number): Observable<Object> {
    return this.httpClient.patch(`/api/device/${id}`, values);
  }

  prodGridRemove(id: number): Observable<Object> {
    return this.httpClient.delete(`/api/deleteDevice/${id}`);
  }

  getOrganizationFilter(): HttpFilterParam[] {
    return [new HttpFilterParam({
      property: 'organization',
      operator: 'in',
      value: this.organizationTreeSelect.ids
    })];
  }
}
